import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-036c8ba7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "template-card-head"
};
const _hoisted_2 = {
  class: "template-card-title"
};
const _hoisted_3 = {
  class: "template-inspo-txt"
};
const _hoisted_4 = {
  class: "template-inspo-txt template-card-subtitle"
};
const _hoisted_5 = {
  key: 0,
  class: "template-card-sublist"
};
const _hoisted_6 = {
  key: 1,
  class: "template-inspo-tip"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TemplateSwipe = _resolveComponent("TemplateSwipe");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["template-card", 'template-card-' + $props.temp.type])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", {
    class: _normalizeClass(["template-card-bar", 'template-card-bar-' + $props.temp.type])
  }, null, 2), _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t($props.temp.title)), 1)]), _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t($props.temp.info)), 1), _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t($props.temp.subTitle || "")), 1), $props.temp.subList ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.temp.subList, subItem => {
    return _openBlock(), _createElementBlock("li", {
      class: "template-card-subitem",
      key: subItem
    }, _toDisplayString(_ctx.$t(subItem)), 1);
  }), 128))])) : _createCommentVNode("", true), $props.temp.subTip ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t($props.temp.subTip)), 1)) : _createCommentVNode("", true), _createVNode(_component_TemplateSwipe, {
    swipes: $props.temp.swipes,
    isMobile: $props.isMobile
  }, null, 8, ["swipes", "isMobile"])], 2);
}